import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { adminOrganizationsKeys } from './adminOrganizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof adminOrganizationsKeys.teams>>;

export const createFetchAdminOrganizationTeamsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminService.getTeams({ oid: organizationId }), signal));
